import { WhichWeightAPI } from 'WhichWeightAPI';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setOrganizationWorkouts } from 'redux/slices/organization';

export const useGetWorkouts = () => {
    
    const dispatch = useDispatch();

    const userId = useSelector(state => state.user.id);
    const organizationId = useSelector(state => state.user.organizationId);
    const cachedWorkouts = useSelector(state => state.organization.workouts);
    
    const [workouts, setWorkouts] = useState(cachedWorkouts);

    const FetchWorkoutsFromBackend = async () => {
        const jsonBody = {
            organizationId: organizationId,
            requestingUserId: userId
        }

        // console.log(jsonBody);

        const result = await WhichWeightAPI("REPORTING", "GET", "/organization_trainee_workouts", jsonBody);

        // console.log(result.data.data);

        if (result.data.status === "failure") {
            console.error(result.data);
            dispatch(setOrganizationWorkouts([]));
            setWorkouts([]);
            return;
        }

        dispatch(setOrganizationWorkouts(result.data.data));
        setWorkouts(result.data.data);
    };

    useEffect(() => {
        if (userId === null) return;
        if (organizationId === null) return;

        if (cachedWorkouts === null) {
            FetchWorkoutsFromBackend();
        }
    }, [cachedWorkouts, dispatch]);

    return workouts;
};
